import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { APIService } from './api.service';
import { Router } from '@angular/router';
import { EncryptionStorageService } from './encryption-storage.service';
@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private readonly menuDataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  menuData$: Observable<any[]> = this.menuDataSubject.asObservable();

  constructor(private readonly apiService: APIService, private readonly router: Router, private readonly encryptStorage: EncryptionStorageService) { }

  setMenuData(menuData: any[]) {    
    this.menuDataSubject.next(menuData);
  }

  getMenuData(): Observable<any[]> {
    return this.menuData$;
  }

  shortNameExists(menuData, shortName: number): boolean {
    if ((this.encryptStorage.getItem('roleName') === 'ParkingOwner') || (this.encryptStorage.getItem('roleName') === 'ParkingManager') ) {    
      return this.checkShortName(menuData, shortName);
    } else {
      return true;
    }
  }

  private checkShortName(menuData: any[], shortName: number): boolean {
    const checkActions = (actions: any[]) => {
      return actions.some(action => action.actionNumber === shortName);
    };
  
    return menuData.some(menu => {
      if (checkActions(menu.actions)) {
        return true;
      }
      if (menu.submenu) {
        return menu.submenu.some(submenu => checkActions(submenu.actions));
      }
      return false;
    });
  }

  redirectionTo(permission, route) {
    if(permission) {
      this.router.navigateByUrl(route)
    }else {
      window.location.reload();
    }
  }
  getRoleBaseMenuAndActionPermission() {
    return this.apiService.get('User/GetRoleBaseMenuAndActionPermission');
  }
}

